import { forwardRef } from "react";
import { StyledText } from "./Text.style.js";
import { DefaultTextProps, TextProps, TextSize, TextWeight } from "./Text.types.js";

const defaultProps: DefaultTextProps = {
    color: "inherit",
    size: TextSize.MEDIUM,
    weight: TextWeight.NORMAL,
    align: "inherit",
    fontStyle: "normal",
};

export const Text = forwardRef<HTMLDivElement, TextProps>((props, ref): JSX.Element => {
    const { children, ...attributes } = { ...defaultProps, ...props };

    return (
        <StyledText ref={ref} {...attributes}>
            {children}
        </StyledText>
    );
});
